/* eslint-disable max-len */

const programmesFederationRemoteEntry = '/gateway/programmes-mf/remoteEntry.js';
const programmesGatewayApiUrl = '/gateway/programmes-api/api';
const programmesRemoteName = 'programmes';
const programmesExposedModule = './Dashboard';
const programmesPortalExposedModule = './Portal';

export const environment = {
  production: true,
  serverUrl: '#{API_URL}#',
  programmesFederationRemoteEntry,
  programmesGatewayApiUrl,
  programmesRemoteName,
  programmesExposedModule,
  programmesPortalExposedModule,
  dateFormat: 'yyyy-MM-dd',
  dayOfTheWeekWithTimeFormat: 'EEEE HH:mm',
  locale: 'en-ZA',
  serviceWorkerEnabled: true,
};
